declare global {
  interface Window {
    __env__?: {
      VITE_ADMIN_API_URL?: string;
    };
  }
}

function env(key: keyof NonNullable<Window['__env__']>): string {
  return window.__env__?.[key] || (import.meta.env as Record<string, string>)[key] || '';
}

export const ADMIN_API_URL =
  env('VITE_ADMIN_API_URL') ||
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3007');
